import { BodyS, Caption, CaptionBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import classNames from 'classnames';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/layouts/adminStyle';
import { makeStyles } from '@material-ui/core';
import apiConfig from 'utils/api/config';

// const SUPPORT_EMAIL = 'SelfServiceSupport@omantel.om';
const SUPPORT_PHONE = '1235';

// @ts-ignore
const useStyles = makeStyles(styles);

const OldFooter = () => {
	const classes = useStyles();
	const footerLinkClasses = classNames(classes.footerLink, classes.footerLinkHover);

	return (
		<div className={classes.footer}>
			<BodyS color="disabled-dark">{translate('copyright')}</BodyS>
			<div className={classes.footerLinks}>
				<div>
					{[
						{ text: 'privacyPolicy', href: apiConfig.links.privacyPolicy },
						{ text: 'copyrights', href: apiConfig.links.copyrights },
						{ text: 'sca', href: apiConfig.links.standardCustomerAgreement },
					].map(({ text, href }) => (
						<a
							href={href}
							key={text}
							target="_blank"
							rel="noopener noreferrer"
							className={footerLinkClasses}
						>
							{translate(`footer.${text}`)}
						</a>
					))}
				</div>
				<div>
					<div className={classes.contactUs}>
						<Caption inline disableMargin color="secondary-dark">
							{translate('footer.contactUs')}
						</Caption>
						<a href={`tel:${SUPPORT_PHONE}`} className={classes.footerLinkHover}>
							<CaptionBold inline disableMargin color="secondary-dark">
								{SUPPORT_PHONE}
							</CaptionBold>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OldFooter;
